/**
 * Native Service - Native (mobil) ortama özel aksiyonlar
 *
 * bridge.isNative kontrolü çağıran tarafta yapılır.
 * Bu fonksiyonlar sadece native mesaj gönderir.
 *
 * Kullanım:
 *   import native from '@/mobile/mobile.fileHandler'
 *   if (bridge.isNative) {
 *     native.downloadFile(url, fileName, 'application/pdf')
 *   }
 */

import bridge from '../core/services/bridge.service';
import SecureLS from 'secure-ls';

const {
  createNativeDownloadRequest,
} = require('../core/services/api-url-policy');

/**
 * Dosya indir — DOWNLOAD_FILE mesajı gönderir (useDownload hook'u yakalar)
 *
 * extraHeaders: Bearer dışında gereken başlıklar (ör. alt şirket için
 * `Company`). Verilmezse davranış değişmez.
 */
export function downloadFile(url, fileName, mimeType, extraHeaders = null) {
  const ls = new SecureLS({ encodingType: 'aes', isCompression: true });
  let token = null;

  try {
    token = ls.get('token');
  } catch (error) {
    token = null;
  }

  const request = createNativeDownloadRequest(
    url,
    process.env.VUE_APP_BACKEND_APP_URL,
    token
  );

  const headers = { ...request.headers };

  Object.entries(extraHeaders || {}).forEach(([key, value]) => {
    // undefined/null deger "undefined" string'i olarak gonderilmesin
    if (value === undefined || value === null || value === '') {
      return;
    }

    // Expo FileSystem.downloadAsync headers'i Record<string, string> bekliyor.
    // Sayi gecirilirse native koprude "cannot be cast to type" hatasi verir;
    // apiHeaders.Company (company_id) number olarak geliyor.
    headers[key] = String(value);
  });

  bridge.send('DOWNLOAD_FILE', {
    url: request.url,
    fileName,
    mimeType,
    headers,
  });
}

/**
 * Dosya seç — PICK_FILE mesajı gönderir (useFilePicker hook'u yakalar)
 */
export function pickFile(accept) {
  bridge.send('PICK_FILE', { accept });
}

export default { downloadFile, pickFile };
